import { lazy, Suspense } from 'react'
import { useFieldHistoryStore } from '@/store/field-history.store'

const FieldHistoryShortcuts = lazy(() =>
  import('./FieldHistoryControls').then(module => ({
    default: module.FieldHistoryShortcuts,
  })),
)

/** Replay imports every module's write hooks; an empty history needs none. */
export function DeferredFieldHistoryShortcuts() {
  const hasHistory = useFieldHistoryStore(
    state => state.undoStack.length > 0 || state.redoStack.length > 0,
  )
  if (!hasHistory) return null

  return (
    <Suspense fallback={null}>
      <FieldHistoryShortcuts />
    </Suspense>
  )
}
